"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarObservationPost = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
class LunarObservationPost extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.LUNAR_OBSERVATION_POST,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SCIENCE],
            cost: 7,
            resourceType: ResourceType_1.ResourceType.DATA,
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
            metadata: {
                description: 'Spend 1 titanium. 1 VP for every 3 data resources here.',
                cardNumber: 'M22',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 data resource to ANY card', (ab) => {
                        ab.data().startAction.asterix();
                    });
                    b.br;
                    b.minus().titanium(1);
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.data(1, 3),
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        super.play(player);
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.DATA));
        return undefined;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 3);
    }
}
exports.LunarObservationPost = LunarObservationPost;
//# sourceMappingURL=LunarObservationPost.js.map